export default __webpack_public_path__ + "static/media/SEBI-Circular-on-KYC.76a256cc.pdf";